<template>
  <div class="detail-page">
    <BreadCrumb :data="breadcrumb" :title="'新闻详情管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <!-- 新闻详情页基本信息 -->
    <DIV v-show="!isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <div class="form-content-img">
          <img
            v-if="newsDetail.cover_image"
            :src="newsDetail.cover_image"
            alt=""
          />
          <img v-else src="../../../../static/image/no-img.png" alt="" />
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>中文名</h4>
            <span>{{ newsDetail.chinese_title }}</span>
          </li>
          <li class="exclusive">
            <h4>英文名</h4>
            <span>{{ newsDetail.english_title }}</span>
          </li>
          <li class="exclusive">
            <h4>来源</h4>
            <span>{{ newsDetail.source }}</span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>{{ newsDetail.source_address }}</span>
          </li>
          <li class="half">
            <h4>主题</h4>
            <span>{{ newsDetail.topic && newsDetail.topic.english_name }}</span>
          </li>
          <li class="half">
            <h4>类型</h4>
            <span>{{ newsDetail.news_type }}</span>
          </li>
          <li
            v-if="newsDetail.offline == 1 && newsDetail.news_type == 'Events'"
            class="half"
          >
            <h4>具体位置</h4>
            <span>{{ newsDetail.position }}</span>
          </li>
          <li v-show="newsDetail.news_type == 'Events'" class="half">
            <h4>地点</h4>
            <div>
              <el-checkbox
                disabled
                label="线上"
                v-model="newsDetail.online"
                :true-label="1"
                :false-label="0"
              ></el-checkbox>
              <el-checkbox
                disabled
                label="线下"
                v-model="newsDetail.offline"
                :true-label="1"
                :false-label="0"
              ></el-checkbox>
            </div>
          </li>
          <li v-if="newsDetail.news_type == 'Events'" class="one-third">
            <h4>发布日期</h4>
            <span v-if="newsDetail.publish_time">{{
              $dtime(newsDetail.publish_time).format("YYYY/MM/DD")
            }}</span>
            <span v-else>暂未发布</span>
          </li>
          <li v-if="newsDetail.news_type == 'Events'" class="one-third">
            <h4>开始日期</h4>
            <span v-if="newsDetail.events_start_time">{{
              $dtime(newsDetail.events_start_time).format("YYYY/MM/DD HH:mm:ss")
            }}</span>
            <span v-else>未确定</span>
          </li>

          <li v-if="newsDetail.news_type == 'Events'" class="one-third">
            <h4>结束时间</h4>
            <span v-if="newsDetail.events_end_time">{{
              $dtime(newsDetail.events_end_time).format("YYYY/MM/DD HH:mm:ss")
            }}</span>
            <span v-else>未确定</span>
          </li>

          <li v-show="newsDetail.news_type == 'Events'" class="one-third">
            <h4>报名</h4>
            <div>
              <el-checkbox
                disabled
                label="是否需要报名"
                v-model="isRegister"
                :true-label="1"
                :false-label="0"
              ></el-checkbox>
            </div>
          </li>

          <!-- <li v-show="newsDetail.news_type == 'Events'" class="half">
            <h4>地点</h4>
            <div>
              <el-checkbox
                disabled
                label="线上"
                v-model="newsDetail.online"
                :true-label="1"
                :false-label="0"
              ></el-checkbox>
              <el-checkbox
                disabled
                label="线下"
                v-model="newsDetail.offline"
                :true-label="1"
                :false-label="0"
              ></el-checkbox>
            </div>
          </li> -->

          <li class="half">
            <h4>状态</h4>
            <el-switch
              v-model="newsDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </DIV>
    <!-- 修改新闻详情基本信息页 -->
    <div v-show="isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <UploadImage
          :img="newsDetail.cover_image"
          :width="390"
          :height="240"
          @getUploadImage="getUploadImage"
          class="form-content-img"
        ></UploadImage>
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>中文名<span>*</span></h4>
            <el-input
              v-model="newsDetail.chinese_title"
              placeholder="请输入中文标题"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>英文名<span>*</span></h4>
            <el-input
              v-model="newsDetail.english_title"
              placeholder="请输入英文标题"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>来源</h4>
            <el-input
              v-model="newsDetail.source"
              placeholder="请输入来源网站名称"
            ></el-input>
            <el-input
              placeholder="请输入内容"
              v-model="newsDetail.source_address"
            >
              <template slot="prepend">链接</template>
            </el-input>
          </li>
          <li class="one-third">
            <h4>主题<span>*</span></h4>
            <el-select
              v-model="newsDetail.topic.id"
              placeholder="请选择主题"
              clearable
            >
              <el-option
                v-for="(item, index) in topicList"
                :key="index"
                :label="item.english_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </li>
          <li class="one-third">
            <h4>类型<span>*</span></h4>
            <el-radio-group v-model="newsDetail.news_type">
              <el-radio label="News" value="News"></el-radio>
              <el-radio label="Events" value="Events"></el-radio>
              <el-radio label="Exploration" value="Exploration"></el-radio>
            </el-radio-group>
          </li>
          <li v-show="newsDetail.news_type == 'Events'" class="one-third">
            <h4>地点</h4>
            <div>
              <el-checkbox
                label="线上"
                v-model="newsDetail.online"
                :true-label="1"
                :false-label="0"
              ></el-checkbox>
              <el-checkbox
                label="线下"
                v-model="newsDetail.offline"
                :true-label="1"
                :false-label="0"
              ></el-checkbox>
            </div>
          </li>
          <br />
          <li v-if="newsDetail.news_type == 'Events'" class="one-third">
            <h4>开始时间</h4>
            <el-date-picker
              v-model="newsDetail.events_start_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </li>
          <li v-if="newsDetail.news_type == 'Events'" class="one-third">
            <h4>结束时间</h4>
            <el-date-picker
              v-model="newsDetail.events_end_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </li>
          <li v-show="newsDetail.news_type == 'Events'" class="one-third">
            <h4>报名</h4>
            <div>
              <el-checkbox
                label="是否需要报名"
                v-model="isRegister"
                :true-label="1"
                :false-label="0"
              ></el-checkbox>
            </div>
          </li>
          <li
            v-if="newsDetail.offline == '1' && newsDetail.news_type == 'Events'"
            class="one-third"
          >
            <h4>具体位置</h4>
            <el-input
              v-model="newsDetail.position"
              placeholder="请输入具体位置"
            ></el-input>
          </li>
          <li class="half">
            <h4>发布日期</h4>
            <el-date-picker
              v-model="newsDetail.publish_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </li>
          <li class="half">
            <h4>状态</h4>
            <el-switch
              v-model="newsDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>

    <div class="pc-newsDetail-register" v-if="isRegister == 1 && isEditting">
      <h2>报名内容</h2>
      <El-button @click="exportRegister()" class="edit-btn">导出报名</El-button>
      <div>
        <el-checkbox
          v-for="item in registerField"
          :key="item.id"
          :label="item.chinese_name"
          v-model="item.isRegister"
          :true-label="1"
          :false-label="0"
        ></el-checkbox>
      </div>
    </div>
    <div class="pc-newsDetail-register" v-if="isRegister == 1 && !isEditting">
      <h2>报名内容</h2>
      <El-button @click="exportRegister()" class="edit-btn">导出报名</El-button>
      <div>
        <el-checkbox
          disabled
          v-for="item in registerField"
          :key="item.id"
          :label="item.chinese_name"
          v-model="item.isRegister"
          :true-label="1"
          :false-label="0"
        ></el-checkbox>
      </div>
    </div>
    <!-- 新闻详情页新闻标签 -->
    <div class="pc-dataDetail-tags">
      <h2>新闻标签</h2>
      <div class="input" v-if="isEditting">
        <keywordsinput :maxLen="18" v-model="newsDetail.tags"></keywordsinput>
      </div>
      <div v-else class="show">
        <p v-for="(tag, index) in newsDetail.tags" :key="index">
          {{ tag }}
        </p>
      </div>
    </div>

    <EditContent
      ref="newsContent"
      :header="'新闻'"
      :content="newsDetail.content"
      :isEditting="isEditting"
      v-show="!isEditting || newsDetail.topic.id != 9"
    ></EditContent>

    <NewsDetailIntro
      ref="dailyNewsContent"
      :isDetail="contentList"
      :editDaily="isEditting && newsDetail.topic.id == 9"
    />

    <div class="works-doc">
      <h2>新闻文件</h2>

      <div class="doc-box">
        <UploadFiles
          v-if="isEditting"
          @getUploadFile="getUploadFile"
          :title="'新闻文件'"
        ></UploadFiles>

        <div class="doc-list">
          <div
            class="doc-item"
            v-for="(item, index) in newsDetail.docs"
            :key="index"
          >
            <p @click="downloadFile(item)">{{ item }}</p>
            <i
              v-show="isEditting"
              @click="removeDocs(index)"
              class="el-icon-error iconPosi"
            ></i>
          </div>
        </div>
      </div>
    </div>

    <SaveGroup
      :isEditting="isEditting"
      @cancelUpdate="cancelUpdate"
      @save="save"
      @recover="recover"
      @view="view"
      @cancelAdd="cancelAdd"
      @add="add"
    />
  </div>
</template>

<script>
import UploadFiles from "../../componentSet/uploadFiles";
import UploadImage from "../../componentSet/uploadImage.vue";
import SaveGroup from "../../componentSet/SaveGroup.vue";
import BreadCrumb from "../../componentSet/BreadCrumb";
import NewsDetailIntro from "./components/NewsDetailIntro.vue";
import EditContent from "../../componentSet/EditContent.vue";
import {
  addNews_Api,
  getTopics_Api,
  getNewsDetial_Api,
  updateNews_Api,
  getRegisterField_Api,
  outputRegister_Api,
} from "../../../apis/news.api";
export default {
  components: {
    UploadImage,
    UploadFiles,
    SaveGroup,
    BreadCrumb,
    NewsDetailIntro,
    EditContent,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "新闻列表", link: "/admin/news" },
        {
          name: "新闻管理",
          link:
            this.$route.query.method == "update"
              ? this.$route.path +
                "?id=" +
                this.$route.query.id +
                "&method=update"
              : this.$route.path + "?method=add",
        },
      ];
    },
  },
  data() {
    return {
      isEditting: true,
      newsDetail: {
        id: null,
        topic_id: null,
        topic: { id: "" },
        tags: [],
        daily_data: [],
        register_field: [],
        docs: [],
      },
      isRegister: 0,
      registerField: [],
      topicList: [],
      content: "",
      contentList: [
        {
          news_id: this.$route.query.id,
          chinese_title: null,
          english_title: null,
          source_address: null,
          outside: 0,
          inside: 0,
        },
      ],
    };
  },
  async mounted() {
    if (this.$global.getLocalData("register_field")) {
      this.registerField = this.$global.getLocalData("register_field");
    } else {
      await this.getRegisterField();
    }
    if (this.$route.query.method == "update") {
      this.newsDetail.id = this.$route.query.id;
      await this.getNewsDetail();
    }

    getTopics_Api().then((res) => {
      this.topicList = res.data;
    });
  },
  methods: {
    getUploadFile(file) {
      console.log(this.newsDetail.doc);
      this.newsDetail.docs.push(file);
    },
    removeDocs(index) {
      this.newsDetail.docs.splice(index, 1);
    },
    downloadFile(item) {
      window.open(item);
    },
    findRegisterField() {
      if (this.newsDetail.register_field.length != 0) {
        this.newsDetail.register_field.forEach((item) => {
          this.registerField.forEach((item2) => {
            if (item.id == item2.id) {
              this.$set(item2, "isRegister", 1);
              console.log(item);
            }
          });
        });
      }
    },
    exportRegister() {
      outputRegister_Api({ event_id: this.newsDetail.id }).then((res) => {
        this.$global.downloadFile(res, "registerList");
      });
    },
    getRegisterField() {
      getRegisterField_Api().then((res) => {
        console.log(res.data);
        this.registerField = res.data;
        this.$global.setLocalData("register_field", this.registerField);
      });
    },
    getUploadImage(img_url) {
      this.newsDetail.cover_image = img_url;
    },
    getNewsDetail(hint) {
      getNewsDetial_Api(this.newsDetail.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";

        this.newsDetail = res.data;
        this.newsDetail.topic == null ? (this.newsDetail.topic = {}) : "";
        this.newsDetail.docs == null ? (this.newsDetail.docs = []) : "";
        this.isRegister = this.newsDetail.register_field.length == 0 ? 0 : 1;
        this.findRegisterField();

        if (this.newsDetail.topic.id == 5) {
          this.newsDetail.content = this.newsDetail.daily_content;
        }
        if (
          this.newsDetail.daily_data &&
          this.newsDetail.daily_data.length != 0
        ) {
          this.contentList = this.newsDetail.daily_data;
        }
        if (!this.newsDetail.publish_time) {
          this.newsDetail.publish_time = this.$dtime(new Date()).format(
            "YYYY-MM-DD"
          );
        }
        if (this.newsDetail.position) {
          this.newsDetail.offline = 1;
        }
        console.log(this.newsDetail);
      });
    },
    // save group 回调函数
    cancelUpdate() {
      this.getNewsDetail("取消成功");
      this.isEditting = false;
    },
    recover() {
      this.getNewsDetail("恢复成功");
    },
    view() {
      window.open(
        "http://wupen.org/newsEvents/" + this.$route.query.id,
        "_blank"
      );
    },
    cancelAdd() {
      window.close();
    },
    add() {
      let formattedData = this.validateForm(this.newsDetail);
      if (!formattedData) {
        return;
      } else {
        addNews_Api(formattedData)
          .then((res) => {
            this.newsDetail = res.data;
            this.isEditting = false;
            this.getNewsDetail();
            this.$router.push({
              path: "/admin/newsdetail",
              query: { id: res.data.id, method: "update" },
            });
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    save() {
      let formattedData = this.validateForm(this.newsDetail);
      if (!formattedData) {
        return;
      } else {
        updateNews_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getNewsDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    edit() {
      this.isEditting = true;
    },
    validateForm(formData) {
      //表单校验
      if (!formData.chinese_title || !formData.english_title) {
        this.$global.error(this, "请输入中英文标题");
        return false;
      }
      if (!formData.news_type) {
        this.$global.error(this, "请选择类型");
        return false;
      }
      if (!formData.topic.id) {
        this.$global.error(this, "请选择主题");
        return false;
      }
      if (formData.offline == "0") {
        formData.position = "";
      }
      // register
      if (this.isRegister == 1) {
        formData.register_field_list = this.registerField
          .filter((item) => {
            return item.isRegister == 1;
          })
          .map((item) => {
            return item.id;
          });
      } else {
        formData.register_field_list = [];
      }
      // daily
      if (formData.topic.id == 5) {
        formData.daily_data = this.$refs.dailyNewsContent.getDailyContent();
        console.log(this.newsDetail.daily_data);
      } else {
        formData.content = this.$refs.newsContent.getContent();
      }
      formData.news_id = formData.id;
      formData.topic_id = formData.topic.id;
      formData.keywords = formData.tags;
      if (formData.docs) {
        formData.docs_list = formData.docs;
      }

      console.log(formData);
      return formData;
    },
  },
};
</script>
<style lang="scss" scoped>
.form-content-img {
  width: 391px;
  height: 220px;
}
.pc-newsDetail-register {
  @include box-model;
  .edit-btn {
    right: 30px;
  }
}
.works-doc {
  @include box-model;
  .doc-box {
    display: flex;
    justify-content: space-between;
    .doc-list {
      width: 850px;
      height: 80px;
      overflow-y: auto;
      overflow-x: hidden;
      .doc-item {
        position: relative;
        margin-bottom: 10px;
        p {
          @include ellipsis;
          width: 800px;
          cursor: pointer;
        }
        i {
          position: absolute;
          top: 0px;
          right: 10px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/news/NewsDetail.vue